export { default as aboutUsReducer } from './slice';
export { aboutUsSagas } from './sagas';
